export default "__VITE_ASSET__BPqHNa8H__"